(function () {
  function getBanner() { return document.getElementById('shopify-pc__banner'); }

  function collapseBanner() {
    var banner = getBanner();
    if (banner) banner.classList.add('namourou-collapsed');
  }

  function expandAndOpenPrefs() {
    var banner = getBanner();
    if (banner) banner.classList.remove('namourou-collapsed');
    var manageBtn = document.querySelector('.shopify-pc__banner__btn-manage-prefs');
    if (manageBtn) manageBtn.click();
  }

  function checkInitialState() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) return;
      var cp = window.Shopify.customerPrivacy;
      if (cp && typeof cp.shouldShowBanner === 'function' && !cp.shouldShowBanner()) {
        collapseBanner();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkInitialState);
  } else {
    checkInitialState();
  }

  document.addEventListener('click', function (event) {
    var collapsedBadge = event.target.closest('#shopify-pc__banner.namourou-collapsed');
    if (collapsedBadge) {
      expandAndOpenPrefs();
      return;
    }
    if (event.target.closest('[data-cookie-preferences]')) {
      event.preventDefault();
      expandAndOpenPrefs();
      return;
    }
    if (event.target.closest('.shopify-pc__banner__btn-accept, .shopify-pc__banner__btn-decline, #shopify-pc__prefs .shopify-pc__prefs__header-actions button')) {
      setTimeout(collapseBanner, 300);
    }
  });
})();
